<template>
  <div style="padding-left:20px" >
    <el-table :data="dataList" border style="width: 100%;margin-top:20px">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" ></el-table-column>
        <el-table-column prop="receivingUnit"  min-width="180" label="接收单位" header-align="center" align="center" ></el-table-column>
        <el-table-column prop="isHandle"  min-width="120" label="处理结果" header-align="center" align="center" >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isHandle==1" size="mini"  effect="plain">已处理</el-tag>
              <el-tag type="info" v-if="scope.row.isHandle==0" size="mini"  effect="plain">未处理</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="isReade"  min-width="120" label="是否已读" header-align="center" align="center" >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isReade==1" size="mini"  effect="plain">已读</el-tag>
              <el-tag type="info" v-if="scope.row.isReade==0" size="mini"  effect="plain">未读</el-tag>
            </template>
          </el-table-column>
        <el-table-column prop="createDate"  min-width="180" label="反馈时间" header-align="center" align="center" ></el-table-column>
        <el-table-column prop="feedbackType"  min-width="180" label="反馈类型" header-align="center" align="center" >
          <template slot-scope="scope">
          <div v-for="item in feedbackTypeOptions" :key="item.dictCode">
            <el-tag v-if="scope.row.feedbackType==item.dictCode" size="mini">{{item.dictName}}</el-tag>
          </div>
        </template>
        </el-table-column>
        <!-- <el-table-column prop="questionContent"  min-width="360" label="反馈内容" header-align="center" align="center" ></el-table-column> -->
        <el-table-column prop="handleDate"  min-width="180" label="处理时间" header-align="center" align="center" ></el-table-column>
        <!-- <el-table-column prop="receivingUnit"  min-width="180" label="回复单位" header-align="center" align="center" ></el-table-column> -->
        <!-- <el-table-column prop="reply"  min-width="360" label="处理内容" header-align="center" align="center" ></el-table-column> -->
      <el-table-column label="操作" width="80" align='center' fixed="right">
        <template slot-scope="scope">
          <div class="ishow">
            <el-button  type="text" size="small"  @click="view(scope.row)">查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:right;margin-top:20px;"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      background
      :total="total"
      layout="total, sizes, prev, pager, next"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>

    <el-dialog  title="查看反馈详情" :visible.sync="zjVisible"  width="700px" :append-to-body='true'>
      <ul class="infodiv">
        <li><div class="left">接收单位：</div><div class="right">{{info.receivingUnit}}</div></li>
        <li><div class="left">反馈时间：</div><div class="right">{{info.createDate}}</div></li>
        <li>
          <div class="left">反馈类型：</div><div class="right">
            <div v-for="item in feedbackTypeOptions" :key="item.dictCode">
              <el-tag v-if="info.feedbackType==item.dictCode" size="mini">{{item.dictName}}</el-tag>
            </div>
          </div>
        </li>
        <li><div class="left">反馈内容：</div><div class="right">{{info.questionContent}}</div></li>
        <li><div class="left">处理时间：</div><div class="right">{{info.handleDate}}</div></li>
        <li><div class="left">回复单位：</div><div class="right">{{info.receivingUnit}}</div></li>
        <li><div class="left" >处理内容：</div><div class="right">{{info.reply}}</div></li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zjVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'examHistory',
  props: ['feedbackTypeOptions'],
  data () {
    return {
      dataList: [],
      zjVisible: false,
      page: 1,
      total: 0,
      limit: 10,
      isReade: '',
      isExamHistoryView: false,
      serviceType: '2',
      receivingUnit: '',
      options: [{
        value: '0',
        label: '咨询'
      }, {
        value: '1',
        label: '举报'
      }, {
        value: '2',
        label: '反馈'
      }],
      options1: [{
        value: '0',
        label: '未读'
      }, {
        value: '1',
        label: '已读'
      }],
      info: {}
    }
  },
  methods: {
    init () {
      let obj = { page: this.page, limit: this.limit, receivingUnit: this.receivingUnit, serviceType: 2, isReade: this.isReade, type: 'msg' }
      this.$get('/training/customerService/page', obj).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.init()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.init()
    },
    // 点击查看
    view (row) {
      this.info = row
      this.yd(row.id)
      this.zjVisible = true
    },
    yd (id) {
      this.$get('/training/customerService/getInfo?id=' + id).then(res => {
        this.init()
      })
    },
    resetHandle () {
      this.receivingUnit = ''
      this.isReade = ''
      this.page = 1
      this.init()
    }
  }
}
</script>
<style scoped>
  .examText1{
    font-size: 22px;padding-bottom: 20px;
  }
   div /deep/ .el-table th{background: #f5f7fa;}
   div /deep/ .el-dialog__body{padding:5px 20px}
   .infodiv li{overflow: hidden;line-height: 30px;padding:3px 0}
   .infodiv .left{width: 80px;float: left;text-align: right;font-weight: bold;}
   .infodiv .right{float: left;color: #666;width: 560px;}
</style>
